import { useContext } from 'react';

import {
  Tabs,
  TabsProps,
  Theme,
  createStyles,
  withStyles,
} from '@material-ui/core';

import { ActivityItemContext } from './ActivityItemContext';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      minHeight: theme.spacing(3),
      marginBottom: theme.spacing(1),
    },
    indicator: {
      // OCD
      height: '1.25px',
    },
  });

const ActivityItemTabs = (props: TabsProps) => {
  const { tab, setTab } = useContext(ActivityItemContext);
  return (
    <Tabs
      data-track-source-anchor="0b31de18c5;activity-item-tabs" {...props}
      value={tab}
      onChange={(_event, value) => setTab?.(value)}
    />
  );
};

export default withStyles(styles)(ActivityItemTabs);
